export const paymentMethods = [{
    id: 'CASH',
    name: 'Dinheiro 💵 (Retirada)',
    isOnlinePayment: false
}, {
    id: 'PIX',
    name: 'Pix 📲 (Online)',
    isOnlinePayment: true
}, {
    id: 'PIX2',
    name: 'Pix 📲 (Retirada)',
    isOnlinePayment: false
}, {
    id: 'DEBIT',
    name: 'Débito 💳 (Retirada)',
    isOnlinePayment: false
}, {
    id: 'CREDIT',
    name: 'Crédito 💳 (Retirada)',
    isOnlinePayment: false
}];